
const getFutureDateAndTime = (dateString) => {

    

    const currentDate = new Date()
    let formattedDate;


    const formattedTime = new Intl.DateTimeFormat('tr-TR', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    }).format(dateString);


    if(currentDate.getDate() === dateString.getDate() && currentDate.getMonth() === dateString.getMonth()){
        formattedDate = "Bugün"
    }

    else if(currentDate.getDate() < dateString.getDate() && currentDate.getMonth() === dateString.getMonth()){
        formattedDate = "Yarın"
    }

    else{
        formattedDate = new Intl.DateTimeFormat('tr-TR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        }).format(dateString);
    }
    return {
        formattedDate,
        formattedTime
    }
}

export default getFutureDateAndTime;